module.exports = __webpack_public_path__ + "img/item4-6.e90ff4ac.jpg";